<app-page-header subtitle="Profiel"> </app-page-header>
<div class="overview">
    <div class="container my-3">
        @if (form) {
            <div class="row justify-content-center">
                <div class="col-24">
                    <form [formGroup]="form">
                        <div class="profile-picture-row">
                            <app-codalt-upload-image
                                class="profile-picture"
                                [fcImage]="form.controls.profile_picture"
                                [fileStorage]="FileStorage.ProfilePictures"
                                [hideControls]="true"
                                [width]="150"
                                [height]="150"
                                [resizedSize]="1200"></app-codalt-upload-image>
                            <div class="text_fields">
                                <div class="mb-2">
                                    <div class="text-muted small">Naam</div>
                                    <div>{{ currentUser?.name }}</div>
                                </div>
                                <div>
                                    <div class="text-muted small">E-mailadres</div>
                                    <div>{{ currentUser?.email }}</div>
                                </div>
                            </div>
                        </div>
                        @if (form) {
                            <div class="row justify-content-center">
                                <div class="col-24">
                                    <div class="d-flex">
                                        <div class="spacer"></div>
                                        <button
                                            id="btn-save"
                                            [disabled]="form.invalid || saving"
                                            (click)="save()"
                                            color="primary"
                                            mat-raised-button>
                                            {{ saving ? 'Opslaan...' : saved ? 'Opgeslagen' : 'Opslaan' }}
                                            @if (saving) {
                                                <i class="fas fa-circle-notch fa-spin"></i>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </div>
                        }
                    </form>
                    <app-user-auth-sessions />
                    <div class="mb-3">
                        <h3>Applicatie versie</h3>
                        <p>
                            Datum: {{ compiledVersion.datetime | date: 'EEEE d MMMM yyyy HH:mm:ss' }}<br />
                            Omgeving: {{ compiledVersion.environment }}<br />
                            Build: {{ compiledVersion.buildNumber }} / {{ compiledVersion.buildId }}
                        </p>
                    </div>
                </div>
            </div>
        }
    </div>

    @if (Functionalities.AfasAuth | hasFunctionality) {
        <app-profile-afas></app-profile-afas>
    }
</div>
